import type { TradeDto } from '@bqcrm/shared';
import { Anchor, Box, Button, Checkbox, Group, Popover, Stack, Text } from '@mantine/core';
import { IconChevronDown, IconFilter } from '@tabler/icons-react';
import { TradeBadge } from '../../components/Badges';

/**
 * Filtr branż (kilka naraz) w jednym niskim przycisku: kolorowe skróty wybranych branż (do 4, potem „+N”),
 * po kliknięciu lista z polami wyboru. Pole nie rośnie przy wielu branżach.
 */
export function TradeFilter({ trades, value, onChange, fullWidth }: { trades: TradeDto[]; value: string[]; onChange: (v: string[]) => void; fullWidth?: boolean }) {
  const active = trades.filter((t) => t.active);
  const shown = value.slice(0, 4);
  const toggle = (code: string, on: boolean) => onChange(on ? [...value, code] : value.filter((c) => c !== code));
  return (
    <Popover position="bottom-end" shadow="md" width={280} withinPortal>
      <Popover.Target>
        <Button
          size="xs"
          variant={value.length ? 'light' : 'default'}
          leftSection={<IconFilter size={14} />}
          rightSection={<IconChevronDown size={14} />}
          w={fullWidth ? '100%' : undefined}
          aria-label="Filtr branż"
          styles={{ label: { gap: 4, display: 'flex', alignItems: 'center' } }}
        >
          {value.length === 0 ? (
            'Wszystkie branże'
          ) : (
            <>
              {shown.map((c) => (
                <TradeBadge key={c} code={c} trade={trades.find((t) => t.code === c)} />
              ))}
              {value.length > shown.length && <Text size="xs">+{value.length - shown.length}</Text>}
            </>
          )}
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Group justify="space-between" mb="xs">
          <Text size="sm" fw={600}>
            Branże
          </Text>
          <Anchor component="button" type="button" size="xs" onClick={() => onChange([])} disabled={!value.length}>
            Wszystkie
          </Anchor>
        </Group>
        <Stack gap={8}>
          {active.map((t) => (
            <Checkbox
              key={t.code}
              size="xs"
              checked={value.includes(t.code)}
              onChange={(e) => toggle(t.code, e.currentTarget.checked)}
              label={
                <Group gap={6} wrap="nowrap">
                  <Box style={{ flexShrink: 0 }}>
                    <TradeBadge code={t.code} trade={t} />
                  </Box>
                  <Text size="sm">{t.name}</Text>
                </Group>
              }
            />
          ))}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
